<ng-container [formGroup]="formGroup">
  <app-dropdown-image
    [options]="customColors$ | async"
    [imagePath]="'mouthguard-custom/'"
    [label]="'dental.attributes.graphic.choose_color' | translate"
    [formControlName]="colorAttributeKey">
  </app-dropdown-image>
</ng-container>

<app-uploader
  [control]="formGroup?.get(fileAttributeKey)"
  [label]="'attributes.graphic.upload_graphic.label' | translateDental"
  [description]="'attributes.graphic.upload_graphic.description' | translateDental"
  [multiple]="false"
  [maxCount]="1"
  [fileableType]="'order-product'"
  [fileableId]="orderProductId"
  [tag]="'graphic1'"
  [extensionsAccepted]="['gif', 'png', 'jpg', 'jpeg', 'pdf', 'shd1']">
</app-uploader>
